import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { claimUserReward } from 'app/state/modules/rewards'

import { GiftCryptoContainer } from './style';

const GiftCrypto = (props) => {
  const [currentCoin, setCurrentCoin] = useState(props.catalogByOrganizationId[props.match.params.organization_uuid].crypto[0].uuid);
  const [address, setAddress] = useState('');
  const availableCrypto = props.catalogByOrganizationId[props.match.params.organization_uuid].crypto
  const onCoinChange = (coin) => {
    setCurrentCoin(coin);
  }

  const addressChanged = (e) => {
    setAddress(e.target.value);
  }
  return (
    <GiftCryptoContainer>
      <p className="title">Delivery Information</p>
      <div className="GiftCrypto_body">
        <p className="sub_title">Reward: Crypto</p>
        <p className="sub_desc">Coin</p>
        <select
          className="uk-select"
          name="coin"
          onChange={e => onCoinChange(e.target.value)}
          defaultValue={currentCoin}
        >
          {availableCrypto.map(crypto => (
            <option value={crypto.uuid} key={crypto.uuid}>
              {crypto.crypto.asset}
            </option>
          ))}
        </select>
        <p className="sub_desc">Wallet Address</p>
        <input
          className="uk-input uk-form-width-large"
          type="text"
          spellCheck={false}
          onChange={addressChanged}
          value={address}
        />
        <p className="uk-text-small">Crypto prices can move very quickly.  This reward will be based on when the current price at the time of transfer.</p>
        <div className="uk-flex uk-flex-right uk-margin-top">
          <button
            className="uk-button uk-button-primary uk-button-small"
            onClick={() => {
              const coinRewarded = props.catalogByOrganizationId[props.match.params.organization_uuid].crypto.find((coin) => coin.uuid === currentCoin)
              props.claimUserReward(props.match.params.organization_uuid, currentCoin, {
                walletAddress: address
              }, () => {
                props.history.push({
                  pathname: '/plan/confirmation',
                  state: {
                    type: 'crypto'
                  }
                })
              }, `We will transfer ${parseFloat(coinRewarded.crypto.currencyValue.amount).toFixed(0)} ${coinRewarded.crypto.currencyValue.currency} worth of ${coinRewarded.crypto.asset} to your wallet shortly. You can check the status of the transfer on your Profile page.`)
            }}
          >
            Claim Reward
          </button>
        </div>
      </div>
    </GiftCryptoContainer>
  )
}
const mapStateToProps = (state) => ({
  // auth
  email: state.auth.user.email,
  user: state.hacker.currentHackerDetails,
  catalogByOrganizationId: state.rewards.catalogByOrganizationId,
})

export default withRouter(connect(mapStateToProps, {
  claimUserReward
})(GiftCrypto))
